export const appId = process.env.REACT_APP_APP_ID || 'app-salonflow';
export const brandingEstabId = process.env.REACT_APP_ESTAB_ID || '';
